import { useContext } from 'react';
import LanguageContext from '../contexts/LanguageContext';
import { translations } from '../i18n/translations';

export const useTranslation = () => {
  const { language } = useContext(LanguageContext);

  const t = (key) => {
    return translations[key]?.[language] || translations[key]?.['FR'] || key;
  };

  return { t, language };
};
